import { Equipment } from "../types/equipmentTypes";
import axios from 'axios';
import { CategoryEquipament } from "../types/categoryEquipaments";
import apiClient from "./apiClient";

// --- TIPOS NUEVOS ---
export interface HistoricalFront {
    id: number;
    label: string;
}

// Función para obtener todos los equipos
export const getEquipment = async (): Promise<Equipment[]> => {
    const response = await apiClient.get('/Equipments');
    return response.data;
};

// Función para obtener categorías
export const getCategoryEquipment = async (): Promise<CategoryEquipament[]> => {
  const response = await apiClient.get('/Category/Equipamnet');
  return response.data;
};

export const getEquipmentByIdProject = async (idProject: number): Promise<Equipment[]> => {
  try{
    const response = await apiClient.get(`/Equipments/project/${idProject}`);
    return response.data;
  }catch(error){
    console.error('Error al obtener los equipos del proyecto:', error);
        throw new Error('Error al obtener los equipos del proyecto.');
  }
};

// Eliminar
export const deleteEquipment = async (id: number): Promise<void> => {
  await apiClient.delete(`/Equipments/${id}`);
};

// Actualizar
export const updateEquipment = async (id: number, updatedEquipment: Partial<Equipment>): Promise<Equipment> => {
    const response = await apiClient.put<Equipment>(`/Equipments`, updatedEquipment);
    return response.data;
};

// Crear
export const createEquipment = async (Equipment: Object): Promise<Equipment> => {
    const response = await apiClient.post<Equipment>(`/Equipments`, Equipment);
    return response.data;
};

// Archivos
export interface ImportResult {
    importados: number;
    fallidos: number;
    errores: string[];
    advertencias?: string[];
    mensaje: string;
}

export const importEquipments = async (file: File): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<ImportResult>(`/Equipments/import`, formData);
    return response.data;
};

export const downloadFormatEquipments = async () => {
    try {
      const response = await apiClient.get(`/Equipments/download-format`,{ responseType: 'blob' });
      const blob = await response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Equiposformato.xlsx';
      a.click();
    } catch (error) {
      console.error('Error al descargar el formato:', error);
    }
};

export const exportEquipments = async () => {
    try {
      const response = await apiClient.get(`/Equipments/export`, { responseType: 'blob' });
      const blob = await response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Equipos.xlsx';
      a.click();
    } catch (error) {
      console.error('Error al exportar Equipos:', error);
    }
};

// =============================================================================
// MÉTODOS PARA MODO HISTÓRICO (FOTOGRAFÍA DIARIA - EQUIPOS)
// =============================================================================

// 1. Obtener equipos de una fecha histórica
export const getEquipmentsByReportDate = async (idProject: number, date: string): Promise<Equipment[]> => {
    const formattedDate = date.includes('T') ? date : `${date}T00:00:00`;
    // Nota: Ajusta la URL base si tu controller tiene otro nombre. Asumo /Daily-report-equipments
    const response = await apiClient.get<Equipment[]>(`/Daily-report-equipments/historical/list`, {
      params: { projectId: idProject, date: formattedDate }
    });
    return response.data;
};

// 2. Obtener frentes disponibles
export const getHistoricalFronts = async (idProject: number, date: string): Promise<HistoricalFront[]> => {
    const formattedDate = date.includes('T') ? date : `${date}T00:00:00`;
    const response = await apiClient.get<HistoricalFront[]>(`/Daily-report-equipments/historical/fronts`, {
      params: { projectId: idProject, date: formattedDate }
    });
    return response.data;
};

// 3. Agregar equipo al reporte histórico con ID de FRENTE
export const addEquipmentToReport = async (
      idProject: number,
      date: string,
      equipment: Partial<Equipment>,
      workFrontId: number
): Promise<void> => {
    const formattedDate = date.includes('T') ? date : `${date}T00:00:00`;
    await apiClient.post(`/Daily-report-equipments/historical/add`, equipment, {
      params: { projectId: idProject, date: formattedDate, workFrontId: workFrontId }
    });
};

// 4. Quitar equipo del reporte histórico
export const removeEquipmentFromReport = async (idProject: number, date: string, equipmentId: number): Promise<void> => {
    const formattedDate = date.includes('T') ? date : `${date}T00:00:00`;
    await apiClient.delete(`/Daily-report-equipments/historical/remove`, {
      params: { projectId: idProject, date: formattedDate, equipmentId: equipmentId }
    });
};

export const getEquipmentByInternalCode = async (code: string): Promise<Equipment | null> => {
    try {
        // Ajusta la URL según tu Controller
        const response = await apiClient.get<Equipment>(`/Equipments/search`, {
            params: { internalCode: code }
        });
        return response.data;
    } catch (error) {
        return null;
    }
};
